import CategoryThumbnail from './category-thumbnail'
export default CategoryThumbnail
